// extracted by mini-css-extract-plugin
export default {"link":"Coaches_link__zgGpk","coach-cards-wrapper":"Coaches_coach-cards-wrapper__R6MYg","filter":"Coaches_filter__YbmdA"};